module.exports = __webpack_public_path__ + "static/img/download_bg_02.70ffddd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download_bg_02.png
// module id = BpwY
// module chunks = 1